import React from 'react';
import Image from '../PageElements/Image/Image';

type GameImageSliderProps = {
    text: string;
    imageId?: string;
    swipeUpLabel: string;
    swipeDownLabel: string;
    swipedUp: () => void;
    swipedDown: () => void;
};

export default class GameImageSlider extends React.Component<GameImageSliderProps, any> {
    dragging = false;
    lastY: number;
    sliderImage: HTMLDivElement | null;
    sliderContainer: HTMLDivElement | null;
    initialSliderHeight = 200;
    intialSliderWidth = 300;
    sliderScaleRatio = 0.3;

    constructor(props: GameImageSliderProps) {
        super(props);

        this.init(true);

        this.mouseDown = this.mouseDown.bind(this);
        this.mouseMove = this.mouseMove.bind(this);
        this.mouseUp = this.mouseUp.bind(this);
    }

    init(firstRun: boolean = false) {
        this.dragging = false;
        this.lastY = (this.initialSliderHeight / 2) * -1;
        if (firstRun === true) {
            this.state = {
                posY: this.lastY,
                scale: 1
            };
        } else {
            this.setState({
                posY: this.lastY,
                scale: 1
            });
        }
    }

    componentWillUnmount() {
        this.dragging = false;
    }

    // mouseDown(ev: React.MouseEvent<HTMLElement>) {
    mouseDown(ev: any) {
        this.dragging = true;
        if (ev.touches !== undefined) {
            this.lastY = ev.touches[0].clientY;
        } else {
            this.lastY = ev.clientY;
        }
    }

    mouseMove(ev: any) {
        if (this.dragging === true) {
            let clientY: number;
            if (ev.touches !== undefined) {
                clientY = ev.touches[0].clientY;
            } else {
                clientY = ev.clientY;
            }
            // check properties set by REF
            if (this.sliderImage !== null && this.sliderContainer !== null) {
                let img = this.sliderImage;
                let cont = this.sliderContainer;

                // calculate box'es y offset from available space (in %)
                //
                // due to the scaling, the calculation's 100% scaling point is
                //     -1 * (sliderScaleRatio * initialSliderHeight)
                // off from the calc(50% - (initialSliderHeight/2)px) starting point.
                // this is resolved by using two scales, each starting from the
                // corrected point yCenter.

                let yMax = cont.offsetHeight - (this.initialSliderHeight * (1 + this.sliderScaleRatio));
                let yCenter = (cont.offsetHeight - this.initialSliderHeight) / 2;
                let y = img.offsetTop - cont.offsetTop;
                let scale: number;

                if (y < yCenter) {
                    // image needs to be shrunk
                    let shrinkRatio = ((yCenter - y) / yCenter) * this.sliderScaleRatio;
                    scale = 1 - shrinkRatio;
                } else {
                    // image needs to be enlarged
                    let yClean = y - yCenter;
                    let yMaxClean = yMax - yCenter;
                    let growRatio = (yClean / yMaxClean) * this.sliderScaleRatio;
                    scale = 1 + growRatio;
                }

                if (y <= 0) {
                    this.props.swipedUp();
                    this.init();
                } else if (y + img.offsetHeight > cont.offsetHeight) {
                    this.props.swipedDown();
                    this.init();
                } else {
                    this.setState({
                        ...this.state,
                        posY: this.state.posY + (clientY - this.lastY),
                        scale
                    });
                    this.lastY = clientY;
                }
            } else {
                throw 'ref: sliderImage oder sliderContainer ist null.';
            }
        }
    }

    // mouseUp(ev: React.MouseEvent<HTMLElement>) {
    mouseUp(ev: any) {
        if (this.dragging === true) {
            this.dragging = false;
        }
    }

    getStyle() {
        return {
            top: 'calc(50% + ' + this.state.posY + 'px)',
            transform: `scale(${this.state.scale})`
        };
    }

    render() {
        return (
            <div
                className="game-image-area"
                onMouseMove={this.mouseMove}
                onTouchMove={this.mouseMove}
                onMouseUp={this.mouseUp}
                onTouchEnd={this.mouseUp}
                ref={(sliderContainer) => this.sliderContainer = sliderContainer}
            >
                <div className="game-image-area-endzone slideup">
                    {this.props.swipeUpLabel}
                </div>
                <div
                    className="game-image-slider"
                    onMouseDown={this.mouseDown}
                    onTouchStart={this.mouseDown}
                    style={this.getStyle()}
                    ref={(sliderImage) => this.sliderImage = sliderImage}
                >
                    {this.props.imageId && <Image data={{ type: 'image', id: this.props.imageId }} className="game-image-slider-image" />}
                    <div className="game-image-slider-text">
                        {this.props.text}
                    </div>
                </div>
                <div className="game-image-area-endzone slidedown">
                    {this.props.swipeDownLabel}
                </div>
            </div>
        );
    }
}